import { AutoAwesomeMotionOutlined as AutoAwesomeMotionOutlinedIcon } from '@mui/icons-material';

const BulkAction = (): JSX.Element => <AutoAwesomeMotionOutlinedIcon fontSize="inherit" />;

export default BulkAction;
